import * as Yup from "yup";

const validObject = Yup.object().shape({
  carrier: Yup.string().nullable(),
  deliveryDate: Yup.date().nullable(),
  invoiceNumber: Yup.string().nullable(),
  invoiceAmount: Yup.number().nullable(),
  notes: Yup.string().nullable(),
});

export const ValidationSchema = validObject;
